<div class="goal-wrapper" [class.unselectable]="goalNode.goal.id === unselectableId" [hidden]="hidePrivate && goalNode.goal.obfuscated" data-test-id="objective-selector-objective">
  <i class="fs-16px sp-mt-2" [uiTooltipTitle]="'objective' | localize" ui-icon ui-tooltip uiTheme="fill" uiType="goal"></i>
  <div class="toggler nc-icon-mini icon ui-1_simple-add" *ngIf="goalNode.children?.length > 0 && !goalNode.expanded" (click)="goalNode.expanded = true"></div>
  <div class="toggler nc-icon-mini icon ui-1_simple-delete" *ngIf="goalNode.children?.length > 0 && goalNode.expanded" (click)="goalNode.expanded = false"></div>
  <div *ngIf="goalNode.goal?.obfuscated">{{ "objective_private" | localize }}</div>
  <div class="goal-title sp-mb-0 private-wrapper" ui-typography uiEllipsis data-test-id="objective-selector-objective-title">
    <span class="gh-badge open" *ngIf="goalNode.goal.private">{{ "private" | localize }}</span
    >{{ goalNode.goal.name }}
  </div>
  <div class="goal-session sp-mb-0" ui-typography uiEllipsis>{{ sessionsMap[goalNode.goal.sessionId].title }}</div>
  <div class="sp-mx-12">
    <ui-assignee-avatar-group *ngIf="goalNode.goal.ownerIds" uiSize="xs">
      <ui-assignee-avatar *ngFor="let assigneeId of goalNode.goal.ownerIds" [fromAssigneeId]="assigneeId" />
    </ui-assignee-avatar-group>
  </div>
  <button class="select-btn sp-ml-auto sp-mr-32" *ngIf="goalNode.goal.id !== unselectableId" (click)="goalSelected(goalNode)" ui-button uiType="primary" uiShape="round" data-test-id="select-button">
    {{ "select" | localize }}
  </button>
</div>
<div *ngIf="goalNode.children && goalNode.children.length > 0 && goalNode.expanded">
  <div class="sp-pl-20" *ngFor="let childNode of goalNode.children">
    <single-goal-selector-goal-tree [goalNode]="childNode" [unselectableId]="unselectableId" [hidePrivate]="hidePrivate"></single-goal-selector-goal-tree>
  </div>
</div>
